var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.temBias.length > 0)?_c('span',[(_vm.measurement)?_c('span',[_vm._v(" "+_vm._s(_vm.$t('components.titles.fromSupervisor')))]):_c('span',[_vm._v(" "+_vm._s(_vm.$t('components.titles.fromMedian')))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }